<template>
    <!-- TODO: Pass input cssNs somehow? (probably not possible without passing the whole @input component) -->
    <div data-style="tailwind" dusk="password" class="crud::form-inputs-Password">

        <div class="flex flex-wrap mt-10 mb-5 pb-10">

            <label class="w-full lg:w-1/3">
                <h5>{{ label }}<span v-if="required" class="text-red-400">*</span></h5>
            </label>

            <div class="w-full lg:w-2/3">

                <div class="flex">

                    <div class="w-full pr-2">

                        <input
                            v-bind:type="[showPassword ? 'text' : 'password']"
                            :class="defaultInputClass"
                            :name="name"
                            :required="required"
                            v-model="password">

                        <password
                            v-model="password"
                            :secure-length="8"
                            :strength-meter-class="defaultMeterClass"
                            :strength-meter-only="true"/>

                    </div>

                    <div class="flex">

                        <button class="text-white px-2 py-2 w-10 h-10 bg-indigo-500 hover:bg-indigo-800 transition rounded-md" @click.prevent="showPassword = !showPassword">
                            <i class="fas"
                               :title="[showPassword ? 'Verberg wachtwoord' : 'Laat wachtwoord zien']"
                               :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
                               aria-hidden="true">
                            </i>
                        </button>

                        <button class="text-white px-2 py-2 w-10 h-10 bg-indigo-500 hover:bg-indigo-800 transition rounded-md ml-2" @click.prevent="generatePassword(); showPassword = true">
                            <i class="fas fa-random"
                               :title="'Genereer een willekeurig wachtwoord.'">
                            </i>
                        </button>

                    </div>

                </div>

                <small class="block mt-2 text-gray-500">{{ instruction }}</small>

                <div v-for="(error, index) in errors"
                     :key="index">
                    <div class="rounded-md border border-red-200 bg-red-50 p-4 mt-2">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                     aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                          clip-rule="evenodd"/>
                                </svg>
                            </div>
                            <div class="ml-3">
                                <div class="text-sm text-red-700">
                                    <p>
                                        {{ error }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Password from "vue-password-strength-meter";

export default {

    components: {
        Password
    },

    props: {
        instruction: String,
        label: String,
        name: String,
        required: Boolean,
        errors: Array,

        defaultInputClass: {
            type: String,
            default: 'focus:border-indigo-500 focus:ring-indigo-500 bg-white text-base block border border-gray-300 px-4 py-2 rounded w-full'
        },

        defaultMeterClass: {
            type: String,
            default: 'relative bg-gray-300 h-2 mt-2 rounded-md'
        },

        size: {
            type: String,
            default: '16'
        },
    },

    data: () => ({
        password: null,
        showPassword: false,
    }),

    methods: {
        generatePassword() {
            // Define char set and empty pass.
            let CharacterSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789![]{}()%&*$#^<>~|';
            let password = '';

            // Loop till max size is hit.
            for(let i = 0; i < this.size; i++) {
                // Set password to a random string based on the char set.
                password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
            }

            // Set random password.
            this.password = password;
        }
    }
};

</script>

<style lang="scss" scoped>

.crud\:\:form-inputs-Password {

    // Overwrite vue-password-strength-meter styling
    .Password {
        max-width: 100%!important;
        margin: 0!important;
    }

}
</style>
